



















































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { MangoPayMandates, MangoPayMandate, BankAccount } from '@/store/mangoPay/types';
import { MandateStatus } from '@/enum/mangoPay/MandateTypes';
import { extendedDate } from '@/filters/date';

@Component({
  name: 'mandate-overview',
  filters: {
    extendedDate,
  },
})
export default class MandateOverview extends Vue {
  @Prop({ required: true }) bankAccount!: BankAccount;
  @Prop({ required: true }) mandate!: MangoPayMandate;
  @Prop({ default: true }) formDisabled: Boolean;

  @Action('mangoPay/fetchBankAccountMandates') fetchBankAccountMandates: Function;
  @Action('mangoPay/deleteMandate') deleteMandate: Function;

  get createMandateUrl() {
    return `/bank-account/${this.bankAccount.Id}/create-mandate`;
  }

  get canCreateMandate() {
    return this.mandate && this.isFailed(this.mandate.Status);
  }

  fetchMandates() {
    this.fetchBankAccountMandates(this.bankAccount.Id);
  }

  cancelMandate(mandate: MangoPayMandate) {
    this.deleteMandate(mandate.Id)
      .finally(() => {
        window.location.reload();
      });
  }

  isActive(status: string) {
    return status === MandateStatus.ACTIVE;
  }
  isCreated(status: string) {
    return status === MandateStatus.CREATED;
  }
  isSubmitted(status: string) {
    return status === MandateStatus.SUBMITTED;
  }
  isFailed(status: string) {
    return status === MandateStatus.FAILED;
  }
}
